import React, { Component } from "react";
import PropTypes from "prop-types";

import style from "./style.module.css";

export class ScenarioContentBlockInfo extends Component {
  constructor() {
    super();
    this.state = {
      tooltip: null
    };
  }

  componentWillMount() {
    window.addEventListener("click", this.hideTooltip);
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.hideTooltip);
  }

  handleScroll = e => {
    if (this.state.tooltip) {
      this.setState({
        tooltip: {
          ...this.state.tooltip,
          ...this.calcTooltipPos(this.state.tooltip.target)
        }
      });
    }
  };

  calcTooltipPos = target => {
    const b = target.getBoundingClientRect();
    const left = b.left + b.width / 2;
    const top = b.bottom;
    return { top, left };
  };

  showTooltip = ({ target }) => {
    this.setState({
      tooltip: {
        ...this.calcTooltipPos(target),
        target
      }
    });
  };

  hideTooltip = e => {
    if (this.state.tooltip) {
      if (!e || e.type !== "click" || e.target !== this.state.tooltip.target) {
        this.setState({
          tooltip: null
        });
      }
    }
  };

  toggleTooltip = e => {
    if (this.state.tooltip) {
      this.hideTooltip();
    } else {
      this.showTooltip(e);
    }
  };

  render() {
    const { title, text, theme, themeName } = this.props;
    const { tooltip } = this.state;
    return (
      <div className={style.contentBlockInfo}>
        <div className={style.titleContainer}>
          <span
            className={`subTitle ${style.iconTitle}`}
            style={{
              color: theme.iconTitleColor,
              cursor: "pointer",
              padding: "5px"
            }}
            onClick={this.toggleTooltip}
            onMouseEnter={this.showTooltip}
            onMouseLeave={this.hideTooltip}
          >
            {title}
            <sup className={style.iconInfo}>
              <img src={`icons/info-${themeName}.png`} />
            </sup>
          </span>
        </div>
        {tooltip && (
          <div>
            <div
              className={style.triangle}
              style={{
                borderColor: `transparent transparent ${
                  theme.textPopupBackground
                } transparent`,
                position: "fixed",
                zIndex: 100,
                left: `${tooltip.left}px`,
                top: `${tooltip.top}px`,
                transform: "translate(-50%, 0)"
              }}
            />
            <div
              style={{
                left: `${tooltip.left}px`,
                top: `${tooltip.top + 10}px`
              }}
              className={style.contentTooltip}
              onClick={this.hideTooltip}
            >
              <div
                style={{
                  background: theme.textPopupBackground
                }}
                className={style.contentTooltipText}
              >
                <p className={``} dangerouslySetInnerHTML={{ __html: text }} />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

ScenarioContentBlockInfo.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/scenario-content/scenario-parameter-block-persons.js